import {
  getMeetingList, getMeetingOrderInfo, requestCreateMeeting, requestMeetingOrderCancel, getMeetingDetail, requestMeetingOrderInfoUpdate
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";  // 导入封装后的axios请求

const state = {};

const getters = {};

const actions = {
  async getMeetingListMethod ({commit}, params) {
    return getMeetingList(getUrl(params)).then(response => response)
  },

  async getMeetingDetailMethod ({commit}, params) {
    return getMeetingDetail(getUrl(params)).then(response => response)
  },

  async createMeetingMethod ({commit}, params) {
    return requestCreateMeeting(params).then(response => response)
  },

  async meetingOrderCancelMethod ({commit}, params) {
    return requestMeetingOrderCancel(params).then(response => response)
  },

  async getMeetingOrderInfoMethod ({commit}, params) {
    return getMeetingOrderInfo(getUrl(params)).then(response => response)
  },

  async meetingOrderInfoUpdate ({commit}, params) {
    return requestMeetingOrderInfoUpdate(params).then(response => response)
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/meeting/meeting.js